var assert = require('nanoassert')
var { CipherState } = require('./cipher-state')
var hash = require('./hash')

class SymmetricState {
  constructor(protocolName) {
    var h
    if (protocolName.length <= hash.HASHLEN) {
      h = Buffer.concat([protocolName, Buffer.alloc(hash.HASHLEN - protocolName.length)])
    } else {
      h = hash.hash(protocolName)
    }

    this.cipherState = new CipherState()
    this.ck = h
    this.h = h
  }

  mixKey(inputKeyMaterial) {
    assert(inputKeyMaterial.length)
    var [ck, tempK] = hash.hkdf(this.ck, inputKeyMaterial, 2)
    this.ck = ck
    // HASHLEN is always 32
    this.cipherState.initializeKey(tempK)
  }

  mixHash(data) {
    this.h = hash.hash(Buffer.concat([this.h, data]))
  }

  mixKeyAndHash(inputKeyMaterial) {
    var [ck, tempH, tempK] = hash.hkdf(this.ck, inputKeyMaterial, 3)
    this.ck = ck
    this.mixHash(tempH)
    // HASHLEN is always 32
    this.cipherState.initializeKey(tempK)
  }

  getHandshakeHash() {
    return this.h.slice(0)
  }

  encryptAndHash(plaintext) {
    var ciphertext = this.cipherState.encryptWithAd(this.h, plaintext)
    this.mixHash(ciphertext)
    return ciphertext;
  }

  decryptAndHash(ciphertext) {
    var plaintext = this.cipherState.decryptWithAd(this.h, ciphertext)
    this.mixHash(ciphertext)
    return plaintext
  }

  split() {
    var [tempK1, tempK2] = hash.hkdf(this.ck, Buffer.alloc(0), 2)
    // HASHLEN is always 32
    var c1 = new CipherState()
    var c2 = new CipherState()
    c1.initializeKey(tempK1)
    c2.initializeKey(tempK2)
    return [c1, c2]
  }
}

module.exports = { SymmetricState }